import { publications, researchAreas } from "../data";
import { PageIntro } from "../components/Shell";
import { ResearchFigure } from "../components/ResearchView";

export default function ResearchPage() {
  return (
    <>
      <PageIntro
        label="Research"
        title="연구"
        aside={
          <>
            Digital marketing · Consumer behavior
            <br />
            Field experiments · Behavioral data
          </>
        }
      />
      <section className="page-section shell">
        <div className="research-document">
          <nav className="research-index" aria-label="연구 주제">
            {researchAreas.map((area, index) => (
              <a href={`#${area.id}`} key={area.id}>
                <span>{String(index + 1).padStart(2, "0")}</span>
                <span>{area.title}</span>
              </a>
            ))}
          </nav>
          <div className="research-sections">
            {researchAreas.map((area, index) => {
              const publication = publications.find(
                (item) => item.id === area.publicationId
              );
              return (
                <article className="research-module" id={area.id} key={area.id}>
                  <header className="research-module-head">
                    <span className="research-module-number">
                      {String(index + 1).padStart(2, "0")}
                    </span>
                    <div>
                      <p className="section-label">{area.label}</p>
                      <h2>{area.title}</h2>
                    </div>
                  </header>
                  <div className="research-module-figure">
                    <ResearchFigure area={area} />
                  </div>
                  <dl className="research-module-meta">
                    <div>
                      <dt>Data · Method</dt>
                      <dd>{area.method}</dd>
                    </div>
                    <div>
                      <dt>Selected publication</dt>
                      <dd lang="en">
                        {publication?.url ? (
                          <a
                            className="external-link"
                            href={publication.url}
                            target="_blank"
                            rel="noreferrer"
                          >
                            {publication.title}
                            <span aria-hidden="true">↗</span>
                          </a>
                        ) : (
                          publication?.title
                        )}
                      </dd>
                    </div>
                  </dl>
                </article>
              );
            })}
          </div>
        </div>
      </section>
    </>
  );
}
